// extracted by mini-css-extract-plugin
export default {"cardWrapper":"CardV2_cardWrapper__WWOn7","card":"CardV2_card__nep4X","title":"CardV2_title__BuwAs","secondaryText":"CardV2_secondaryText__dQRwY","footer":"CardV2_footer__FRC77"};